import React, { useEffect } from 'react';
import { connect, useDispatch } from "react-redux";
import { bindActionCreators, compose } from "redux";
import Typography from "@material-ui/core/Typography";
import { FormProvider, useForm } from "react-hook-form";
import { useData } from "../../common/DataContext";
import { MainContainer } from "../../common/ReactHookForm/MainContainer";
import FileUpload from "../../common/FileUpload/FileUpload";
import { Form } from "../../common/ReactHookForm/Form";
import { SubmitButton } from "../../common/ReactHookForm/SubmitButton";
import * as fileActions from "../../../actions/Files";
import * as fileConstants from "../../../components/constants/fileConstants";


const ddPcrAdd = (props) => {
    const { data, setValues } = useData();

    const ddpcrTypes = fileConstants.ENDPOINTS.validDdpcrFileTypes;

    const { actions, fileReducer: { fileId }, fileUploadCompleted } = props;

    const { control, handleSubmit } = useForm({
        defaultValues: {
            files: data.files
        },
    });

    const onSubmit = (data) => {
        // console.log({ data });
        setValues(data);
    };

    useEffect(() => {
        actions.clearUploadFiles();
        actions.setFileId();

        return () => {
            actions.clearUploadFiles();
        }

    }, [])

    return (
        <MainContainer>
            <Typography component="h2" varaiant="h5">
                File Upload
            </Typography>
            <Form onSubmit={handleSubmit(onSubmit)}>


                <FileUpload name="files" fileId={fileId} control={control} props={props} fileType={ddpcrTypes} fileClass="ddpcr" />
                {/* <SubmitButton> Next </SubmitButton> */}

            </Form>

        </MainContainer >
    );
}

const stateToProps = state => ({

    fileReducer: state.fileReducer,
    fileUploadCompleted: state.fileReducer.fileUploadCompleted,
    filesS3: state.fileReducer.filesS3
});

const dispatchToProps = dispatch => ({
    actions: bindActionCreators(
        Object.assign({}, fileActions),
        dispatch
    )
});

export default compose(connect(stateToProps, dispatchToProps),)(ddPcrAdd);
